import { useCallback } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';

import { RouteParamCollection } from 'types/routes';
import { routeBuilder } from 'utilities/routes';

export const useNavigateTo = () => {
  const navigate = useNavigate();

  return useCallback(
    <K extends string>(
      path: K,
      navigateToOptions?: { options?: NavigateOptions; params?: RouteParamCollection<K> }
    ) => {
      const { options, params } = navigateToOptions ?? {};
      const url = routeBuilder(path, params);

      navigate(url, options);
    },
    [navigate]
  );
};
